import { render } from "./ReleaseNote.vue?vue&type=template&id=0736f0be"
import script from "./ReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReleaseNote.vue?vue&type=script&lang=js"

import "./ReleaseNote.vue?vue&type=style&index=0&id=0736f0be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__